import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// ScrollToTop: scrolls to top on every route change.
// On every navigation AFTER the first load, performs a hard reload so that
// the Android WebView fires onPageStarted — which triggers the AdMob
// interstitial already wired up in HomeActivity.
//
// Before the hard reload, any playerVideo passed in route state is saved to
// sessionStorage so VideoDetails can restore it after the page reloads.
const ScrollToTop = () => {
  const location = useLocation();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      const root = document.getElementById("root");
      if (root) root.scrollTop = 0;

      // Google Analytics page view
      try {
        if (typeof window !== "undefined" && window.gtag) {
          window.gtag("config", "G-8M0ZMDB6S3", {
            page_path: location.pathname,
          });
        }
      } catch (e) {}

      if (isFirstLoad.current) {
        // First load: the Android app already fired the interstitial at startup.
        isFirstLoad.current = false;
        return;
      }

      // Subsequent navigations: save playerVideo to sessionStorage before
      // hard reload so VideoDetails can pick it up after the page reloads.
      try {
        const playerVideo = location.state && location.state.playerVideo;
        const key = "pv_" + location.pathname;
        if (playerVideo) {
          sessionStorage.setItem(key, JSON.stringify(playerVideo));
        }
      } catch (e) {}

      // Hard reload to the current URL — triggers WebView onPageStarted
      // which fires the AdMob interstitial in HomeActivity.
      window.location.href = location.pathname + (location.search || "");
    } catch (e) {
      // ignore — never crash the app
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
